import { render, staticRenderFns } from "./Click2buy.vue?vue&type=template&id=0150a478&scoped=true&"
import script from "./Click2buy.vue?vue&type=script&lang=js&"
export * from "./Click2buy.vue?vue&type=script&lang=js&"
import style0 from "./Click2buy.vue?vue&type=style&index=0&id=0150a478&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0150a478",
  null
  
)

export default component.exports